import { CustomValidators } from '@shared-ikp/utils/validators';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { schema, validate } from '@angular/forms/signals';
import { validateWithControlValidator } from '@shared-ikp/utils/signal-forms.util';

export interface DatumFormValue {
  ummeldedatum: NgbDateStruct | null;
}

export const datumSchema = schema<DatumFormValue>(path => {
  validate(path.ummeldedatum, validateWithControlValidator(CustomValidators.ummeldedatumValidator, 'ummeldedatum'));
});
